import { demoApp } from './demo-app';
import { setupClient } from './demo-client-setup';
import { readBootstrapDataFromUrl } from './demo-helpers';
import { TellentClient } from '../app/tellent-client';

const { appKind, baseHref } = readBootstrapDataFromUrl();
const base = <HTMLBaseElement>document.getElementById('docbase')!;
base.href = `/${baseHref}/`;

const client = new TellentClient({
  env: 'local-staging',
  navigationScope: ['recruitment', 'core_hr', 'grow', 'admin'],
  brand: 'javelo',
  toastCallbacks: {
    success: message => console.warn(message),
    error: message => console.warn(message),
  },
  baseHref: `/${baseHref}`,
});

client
  .initWithSelfAuth(appKind)
  .then(data => {
    setupClient(client, data, appKind);

    demoApp();
  })
  .catch(err => {
    console.error(err);
  });
